/** Local mock PIN hash. This is not a production password store. */
export function hashPin(pin: string): string {
  let hash = 2166136261
  const salted = `clnicl-leave-pin:${pin}`
  for (let i = 0; i < salted.length; i += 1) {
    hash ^= salted.charCodeAt(i)
    hash = Math.imul(hash, 16777619)
  }
  return `fnv:${(hash >>> 0).toString(16).padStart(8, '0')}`
}

export function isSixDigitPin(pin: string): boolean {
  return /^\d{6}$/.test(pin)
}

export function generatePin(): string {
  const buffer = new Uint32Array(1)
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(buffer)
    return String(buffer[0] % 1_000_000).padStart(6, '0')
  }
  return String(Math.floor(Math.random() * 1_000_000)).padStart(6, '0')
}
